import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform, AnimatePresence } from 'framer-motion';
export function FloatingCTA() {
  const {
    scrollY
  } = useScroll();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    return scrollY.onChange(latest => {
      setIsVisible(latest > 600);
    });
  }, [scrollY]);
  return <AnimatePresence data-id="element-26">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-6 left-0 right-0 z-50 px-4 md:hidden" data-id="element-27">
          <a href="https://vidaclave.online/cart/52657963008367:1" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full bg-[#D4A574] text-[#1C1C2E] font-bold text-center py-4 rounded-full shadow-lg shadow-black/40 border border-[#F5F0E8]/20" data-id="element-28">
            <span className="text-[#1C1C2E]/50 line-through text-sm" data-id="element-29">
              USD 17
            </span>
            <span data-id="element-30">USD 6.39 — Descargar Ahora</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}